import { API_URL } from "../config";

// A call to the API with the signed-in person's token.
// Resolves to { ok, status, data }; "data" is the reply as JSON (or {} when there is none).
export async function apiCall(path, { method = "GET", body } = {}) {
    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers: {
            Accept: "application/json",
            ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

    const data = await response.json().catch(() => ({}));
    return { ok: response.ok, status: response.status, data };
}

// "Sat, 24 Oct 2026"
export function formatDay(value) {
    if (!value) return "";
    const text = String(value);
    const date = new Date(text.length === 10 ? `${text}T00:00:00` : text);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
}

// "Sat, 24 Oct 2026, 14:05"
export function formatDayTime(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return `${formatDay(value)}, ${date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
}
